/**
 * Where to send someone after they sign in, read from `?redirect=`.
 *
 * Only a path on this origin is honoured. Anything else — `https://…`, or the
 * protocol-relative `//evil.example` and `/\evil.example` that browsers treat
 * as off-site — falls back, so a crafted link can't use our sign-in page to
 * bounce someone to another site.
 */
export function safeRedirect(search: string, fallback = '/apps'): string {
  const raw = new URLSearchParams(search).get('redirect');
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  return raw;
}

/** `?redirect=…` to carry onto a sibling auth page, or '' when there is none. */
export function carryRedirect(search: string): string {
  const target = safeRedirect(search, '');
  return target ? `?redirect=${encodeURIComponent(target)}` : '';
}
